import { I18n } from "@/i18n/I18n";

export function FileUploadWrapper(props: { children: React.ReactNode, uploading: boolean, uploadProgress: number }) {
  const { children, uploading, uploadProgress } = props;

  if (uploading) {
    return (
      <div className="d-flex flex-column gap-1" role="status" aria-label={I18n.get('uploading')}>
        <span>{I18n.get('uploading')}</span>
        <div className="d-flex justify-content-between">
          <SegmentedProgressBar percent={uploadProgress} />
          <span>{I18n.get('percentComplete', { percent: String(uploadProgress) })}</span>
        </div>
      </div>
    );
  }

  return children;
}

const PROGRESS_SEGMENTS = 20;

function SegmentedProgressBar({ percent }: { percent: number }) {
  const filledCount = Math.round((percent / 100) * PROGRESS_SEGMENTS);

  return (
    <div className="fusa-progress">
      {Array.from({ length: PROGRESS_SEGMENTS }, (_, i) => (
        <div
          key={i}
          className={`fusa-progress-segment ${
            i < filledCount
              ? 'fusa-progress-segment--filled'
              : 'fusa-progress-segment--empty'
          }`}
        />
      ))}
    </div>
  );
}
